// When updating button colors, use customeTheme colors instead of customPalette

// eslint-disable-next-line import/prefer-default-export
export const CustomPalette = {
  BLACK: "#000",
  WHITE: "#FFFFFF",
  GREY_800: "#4f4f4f",
  GREY_600: "#787878",
  GREY_300: "#c4c4c4",
  GREY_200: "#efefef",
  BLUE_900: "#001785",
  BLUE_700: "#1e35a5",
  PRIMARY: "#94002a", // primaryColor
  BLUE_300: "#717ecf",
  BLUE_200: "#c2c7eb",
  BLUE_100: "#f2f3fb",
  PINK_200: "#fff4f5",
  PINK_400: "#ffd1d5",
  GREEN_400: "#4CBB17",
  SECONDARY: "#ce1141", // secondaryColor
  RED_100: "#ffc2d2",
  DARK: "#66011e"
};

export default CustomPalette;
